import { Text, View } from '@react-pdf/renderer'
import { PDF_COLORS } from 'pages/reporting/shared/pdfGeneration/constants/colors'
import { PDFStyles } from 'pages/reporting/shared/pdfGeneration/styles/PDFStyles'
import React from 'react'

interface PageSubheaderProps {
  title: string
  color?: string
  align?: 'left' | 'center' | 'right'
}

export const PageSubheader: React.FC<PageSubheaderProps> = ({
  title,
  color = PDF_COLORS.TEXT_PRIMARY,
  align = 'left',
}) => {
  let justifyContent: 'flex-start' | 'center' | 'flex-end' = 'flex-start'
  if (align === 'center') justifyContent = 'center'
  if (align === 'right') justifyContent = 'flex-end'

  return (
    <View style={[PDFStyles.subheaderContainer, { justifyContent }]}>
      <View style={PDFStyles.decorationContainer}>
        <View style={PDFStyles.decorativeLongLine} />
        <View style={PDFStyles.decorativeShortLine} />
        <View style={PDFStyles.decorativeMediumLine} />
      </View>
      <Text style={[PDFStyles.subheaderTitle, { color }]}>{title}</Text>
    </View>
  )
}
